import SelectionState from "state/selections/SelectionState";
import SummaryType from "state/selections/Constants/SummaryType";
import { titleCase } from "@ls/js-utils";
import {
  selectDefinitions,
  selectFetchingData,
  selectFetchingTeSbsData,
} from "./selectors";
import { useDispatch, useSelector } from "react-redux";
import React from "react";
import { selectSideBySideValue } from "state/selections/selector";

import { deleteColumn } from "state/grid/actions";

export const useColumnDefinitions = () => {
  const definitions = useSelector(selectDefinitions(SelectionState.COMMITTED));
  const fetchingAbsData = useSelector(selectFetchingData(SummaryType.ABSOLUTE));
  const fetchingRelData = useSelector(selectFetchingData(SummaryType.RELATIVE));
  const fetchingAbsSbsData = useSelector(
    selectFetchingTeSbsData(SummaryType.ABSOLUTE)
  );
  const fetchingRelSbsData = useSelector(
    selectFetchingTeSbsData(SummaryType.RELATIVE)
  );
  const sideBySide = useSelector(
    selectSideBySideValue(SelectionState.COMMITTED)
  );
  const dispatch = useDispatch();
  return React.useMemo(() => {
    return definitions.reduce((colDefs, definition) => {
      const { factor, covarianceType, summary } = definition;
      const colId = `te_${summary}_${covarianceType}_${factor}`;
      const colDef = {
        headerName: `Tracking Error ${titleCase(factor)} ${titleCase(
          covarianceType
        )} ${titleCase(summary)}`,
        field: colId,
        colId: colId,
        X_onDelete: () => dispatch(deleteColumn(definition)),
      };

      if (
        (summary === SummaryType.ABSOLUTE && fetchingAbsData) ||
        (summary === SummaryType.RELATIVE && fetchingRelData)
      ) {
        colDef.loading = true;
      }
      colDefs.push(colDef);
      if (sideBySide) {
        const sbsColDef = { ...colDef };
        sbsColDef.colId += " - scenario";
        sbsColDef.field += " - scenario";
        sbsColDef.headerName += " - scenario";
        sbsColDef.loading =
          (summary === SummaryType.ABSOLUTE && fetchingAbsSbsData) ||
          (summary === SummaryType.RELATIVE && fetchingRelSbsData);
        sbsColDef.X_sbs = true;
        sbsColDef.X_originalColId = colId;
        sbsColDef.X_backgroundColor = "#fffb95";
        colDefs.push(sbsColDef);
      }
      return colDefs;
    }, []);
  }, [
    definitions,
    dispatch,
    fetchingAbsData,
    fetchingRelData,
    fetchingAbsSbsData,
    fetchingRelSbsData,
    sideBySide,
  ]);
};
